import React from 'react';
import './ServiceGrid.css';
import carWashImg from '../assets/Automatic Car Wash service.png';
import ceramicCoatingImg from '../assets/Ceramic Coating service.png';
import grapheneCoatingImg from '../assets/Graphene Coating service.png';
import boropheneCoatingImg from '../assets/Borophene Coating service.png';
import ppfImg from '../assets/Paint Protection Film (PPF) service.png';
import windshieldImg from '../assets/Windshield Protection Film service.png';
import sprayablePpfImg from '../assets/Sprayable PPF service.png';
import steamWashImg from '../assets/Steam Wash service.png';
import bikeDetailingImg from '../assets/Bike Detailing service.png';
import windowFilmsImg from '../assets/Window Films service.png';
import paintingDentingImg from '../assets/Painting & Denting Services service.png';
import carModificationsImg from '../assets/Car Modifications service.png';
import interiorCleaningImg from '../assets/Deep Interior Cleaning service.png';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    title: 'Automatic Car Wash',
    description: 'Experience a true xpress car wash powered by our 360° touchless system. As a professional car wash company, we use high-pressure jet sprays, rotary arms, and environmentally sound water consumption to detail your vehicle top to bottom in just 10 minutes. Add a hydrophobic layer for shine and long-lasting protection.',
    image: carWashImg,
  },
  {
    title: 'Ceramic Coating',
    description: 'Provide your car with long-lasting gloss and protection. Our ceramic coating adds a resistant layer against UV rays, acid rain, and fine scratches—reducing maintenance while delivering premium results like the best car spa services near me.',
    image: ceramicCoatingImg,
  },
  {
    title: 'Graphene Coating',
    description: 'Want something stronger than ceramic? Our graphene coating offers superior heat resistance, reduced dust accumulation, and swirl mark prevention—ideal for vehicles exposed to harsh environments.',
    image: grapheneCoatingImg,
  },
  {
    title: 'Borophene Coating',
    description: 'The most futuristic coating available. Borophene protects against oxidation and minor abrasions while being lightweight and flexible—perfect for next-generation durability and shine.',
    image: boropheneCoatingImg,
  },
  {
    title: 'Paint Protection Film (PPF)',
    description: 'Invisible paint armor. Our PPF protects against chips, debris, and UV rays while self-healing minor scratches with heat—keeping your car looking new for years.',
    image: ppfImg,
  },
  {
    title: 'Windshield Protection Film',
    description: 'Enhance safety and visibility with our windshield protection film. It reduces glare, blocks UV rays, and prevents micro-cracks from becoming major damage.',
    image: windshieldImg,
  },
  {
    title: 'Sprayable PPF',
    description: 'Enjoy seamless protection with sprayable PPF. It adheres perfectly to curved surfaces, offering flexibility, durability, and a flawless finish without visible film lines.',
    image: sprayablePpfImg,
  },
  {
    title: 'Steam Wash',
    description: 'Looking for the best car spa services near me? Our steam wash is a chemical-free solution that is safe for paint and electronics while effectively removing grease, grime, and bacteria.',
    image: steamWashImg,
  },
  {
    title: 'Bike Detailing',
    description: 'Your two-wheeler deserves expert care. We clean, polish, and restore every component—from chains to chrome—for a complete detailing experience.',
    image: bikeDetailingImg,
  },
  {
    title: 'Window Films',
    description: 'Reduce heat, block UV rays, and enhance privacy with bubble-free window films that comply with local regulations.',
    image: windowFilmsImg,
  },
  {
    title: 'Painting & Denting Services',
    description: 'From minor dents to full repainting, we restore your car’s factory finish with precision and high-quality materials.',
    image: paintingDentingImg,
  },
  {
    title: 'Car Modifications',
    description: 'Upgrade your vehicle with performance enhancements or aesthetic customizations like alloy wheels, lighting kits, and body kits.',
    image: carModificationsImg,
  },
  {
    title: 'Deep Interior Cleaning',
    description: 'As a professional car wash company, we go beyond basic cleaning—sanitizing your cabin with deep cleaning of seats, mats, and AC vents using eco-safe steam solutions for a fresh, odor-free interior.',
    image: interiorCleaningImg,
  },
];

// Mapping from service title to slug
const serviceTitleToSlug = {
  'Automatic Car Wash': 'automatic-car-wash',
  'Ceramic Coating': 'ceramic-coating',
  'Graphene Coating': 'graphene-coating',
  'Borophene Coating': 'borophene-coating',
  'Paint Protection Film (PPF)': 'paint-protection-film',
  'Windshield Protection Film': 'windshield-protection-film',
  'Sprayable PPF': 'sprayable-ppf',
  'Steam Wash': 'steam-wash',
  'Bike Detailing': 'bike-detailing',
  'Window Films': 'window-films',
  'Painting & Denting Services': 'painting-denting-services',
  'Car Modifications': 'car-modifications',
  'Deep Interior Cleaning': 'deep-interior-cleaning',
};

const ServiceGrid = () => {
  const navigate = useNavigate();
  return (
    <div className="service-grid-container container">
      {services.map((service, index) => (
        <div className="service-card" key={index}>
          <img src={service.image} alt={service.title} />
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          <button onClick={() => {
            const slug = serviceTitleToSlug[service.title];
            if (slug) navigate(`/services/${slug}`);
          }}>Know More →</button>
        </div>
      ))}
    </div>
  );
};

export default ServiceGrid;
